module.exports = __webpack_public_path__ + "img/cetificacion-tenologias.d34f9ce0.png";